"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var icons_1 = require("../../utils/icons");
var questionsAndAnswer_json_1 = __importDefault(require("../../utils/questionsAndAnswer.json"));
var styled_1 = require("./styled");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
function Option(_a) {
    var content = _a.content, onSelect = _a.onSelect, activeId = _a.activeId;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles_module_scss_1.default.option }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(styles_module_scss_1.default.optionHeader), onMouseDown: function () { return onSelect(content.id); } }, { children: [(0, jsx_runtime_1.jsx)("p", { children: content.title }), activeId === content.id ? (0, jsx_runtime_1.jsx)(icons_1.CheckBoxLessIcon, {}) : (0, jsx_runtime_1.jsx)(icons_1.CheckBoxMoreIcon, {})] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(styles_module_scss_1.default.optionDescription, " ").concat(activeId === content.id ? styles_module_scss_1.default.optionDescriptionActive : '') }, { children: (0, jsx_runtime_1.jsx)("p", { dangerouslySetInnerHTML: { __html: content.description } }) }))] })));
}
function QuestionAndAnswersContainer() {
    var _a = (0, react_1.useState)('tb1'), optionSelected = _a[0], setOptionSelected = _a[1];
    var _b = (0, react_1.useState)(''), contentActive = _b[0], setContentActive = _b[1];
    function handleOpenTab(id) {
        if (contentActive === id) {
            setContentActive('');
            return;
        }
        setContentActive(id);
    }
    return ((0, jsx_runtime_1.jsxs)(styled_1.Container, { children: [(0, jsx_runtime_1.jsx)(styled_1.Tabs, { children: questionsAndAnswer_json_1.default.options.map(function (option) { return ((0, jsx_runtime_1.jsx)(styled_1.Tab, __assign({ className: optionSelected === option.id ? 'activeTab' : undefined, type: "button", onClick: function () { return setOptionSelected(option.id); } }, { children: option.label }), option.id)); }) }), (0, jsx_runtime_1.jsx)("div", __assign({ className: styles_module_scss_1.default.containerAccordion }, { children: questionsAndAnswer_json_1.default.content[optionSelected].map(function (content) { return ((0, jsx_runtime_1.jsx)(Option, { content: content, onSelect: function (id) { return handleOpenTab(id); }, activeId: contentActive }, content.id)); }) }))] }));
}
exports.default = (0, react_1.memo)(QuestionAndAnswersContainer);
